import React from "react";
import { Badge, Form, Grid, Label, Nav, NavItem, Row, Table } from "react-bootstrap";
import { Button, InputNumber, Select, Spin } from "antd";
import ReactCSSTransitionGroup from "react-addons-css-transition-group"; // ES6
import "../static/css/TableCell.css";
import $ from "jquery"; //TODO: USE fetch instead
import ConfigGetter from "../utils/ConfigGetter";
import isPC from "../utils/isPC";
import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts";
import { CloudDownloadOutlined, DisconnectOutlined, LinkOutlined, ReloadOutlined } from "@ant-design/icons";
import openNotificationWithIcon from "../utils/Tools";
import PortfolioTables from "../component/portfolio-table";
import strategyConfigs from "../component/strategy-configs";
import roundPrecision from "round-precision";
import ReactHighcharts from "react-highcharts";
import ReactHighstock from "react-highcharts/ReactHighstock";

const cnf = ConfigGetter.getConfig();
const defaultPortfolio = "vol";
const max_dynamic_data = 5000;

let UPDATE_INTERVAL = +(localStorage.getItem("updateFrequency") || 1000);
let CleanHeapInterval = null;
let CheckFrequencyInterval = null;

const length_map = {
    "7D": 7,
    "14D": 14,
    "1M": 30,
    "3M": 3 * 30,
    "6M": 6 * 30,
    "1Y": 12 * 30,
};

class ManualTable extends React.Component {
    constructor (props) {
        super(props);
        this.state = {
            data: {}
        };
    }

    updateManualConfig () {
        let data = this.state.data;
        let newObj = {};
        newObj.data = data;
        newObj.tabName = this.props.tabName;
        newObj.tableName = this.props.tableName;

        let that = this;
        $.ajax({
                method: "post",
                url: cnf["restUrl"] + "/strategy_status/updateManual/" + strategyConfigs[that.props.portfolio],
                data: JSON.stringify(newObj),
                contentType: "application/json",
                dataType: "json",
                success: (res) => {
                    alert(`updated successfully: \r\n${Object.keys(data).map(k => k + " = " + data[k]).join("\r\n")}`);
                    // console.log(res);
                },
                error: (res) => {
                    if (res.responseText === "ok") {
                        alert(`updated successfully: \r\n${Object.keys(data).map(k => k + " = " + data[k]).join("\r\n")}`);
                    }
                    else {
                        console.error(res);
                    }
                }
            }
        );
    }

    handleChange (e, field) {
        // e.preventDefault();
        let data = this.state.data;
        // data[field] = e.target.value;
        data[field] = e;
        this.setState({
            data: data
        });
    }

    render () {
        const isAdmin = localStorage.getItem("username") === "jesse";

        let rows = this.props.data;
        rows = rows.map((e) => {
            let keys = Object.keys(e);
            return keys.map((item) => {
                let longest_length = Math.max(6, (e[item].toString() || "").length);
                let width = longest_length * 16 + "px";
                return (<li style={{ display: "inline-block", padding: "20px" }} key={item}>
                    <Badge style={{ padding: "7px 7px 5px 7px" }}>{item}</Badge> <InputNumber style={{ width: width }}
                                                                                              onChange={(evt) => this.handleChange(evt, item)}
                                                                                              defaultValue={e[item]}/>
                </li>);
            });
        });
        return (<ul style={{ listStyleType: "none", textAlign: "center", margin: 0, padding: 0 }}>
            {rows.map((e) => {
                return e;
            })}
            <li hidden={!isAdmin}><Button onClick={(e) => this.updateManualConfig(e)}>Update</Button></li>
        </ul>);
    }
}

class AccountTable extends React.Component {
    constructor (props) {
        super(props);
        this.state = {
            data: props.data,
            changed: {}
        };
    }

    buildTableBody () {
        let rows;
        if (!this.props.data.rows) {
            rows = [];
            // alert('Config contents are missing')
        }
        else {
            rows = this.props.data.rows;
        }
        rows = rows.map((row, index) => {
            let keys = Object.keys(row);
            let formatted = [];
            keys.forEach((key, index) => {
                formatted.push(<td key={key}>{key}</td>);
                formatted.push(<td key={index}>
                    <ReactCSSTransitionGroup transitionName={"numChanging"}
                                             transitionAppear={true} transitionEnterTimeout={1000}
                                             transitionAppearTimeout={1000} transitionLeave={false}>
                        <div className="singleLineCell" key={row[key]} style={{ textAlign: "right" }}>
                            {row[key]}
                            {/*{(!row[key] || isNaN(+row[key])) ? row[key] : parseFloat(row[key].val)}*/}
                        </div>
                    </ReactCSSTransitionGroup></td>
                );
            });
            return (<tr key={index}>{formatted}</tr>);
        });
        return (<tbody>
        {rows.map((e) => {
            return e;
        })}
        </tbody>);
    }

    render () {
        //console.log(this.props.accountName);
        // const odd_second = new Date().getSeconds() % 2 === 1;
        const timeAlarm = !this.props.data.updatedAt || (Date.now() - this.props.data.updatedAt > (this.props.data.latency || 60000));
        const cn = timeAlarm ? "timeAlarm" : undefined;

        return (<Row>
            <h3 style={{ width: "200px", marginTop: "10px", float: "left" }}><Label>{this.props.accountName}</Label>
            </h3>
            <div className={cn} style={{ float: "right", marginTop: "25px" }}>
                <b style={{ fontSize: "large" }}>{global.ws["readyState"] ? <LinkOutlined/> :
                    <DisconnectOutlined/>}</b> &nbsp;&nbsp;
                <b style={{ fontSize: "large" }}><CloudDownloadOutlined onClick={() => {
                    global.ws.send(JSON.stringify({ snapshot: true }));
                    openNotificationWithIcon(true, `Request for snapshot successfully.`);
                }}/></b> &nbsp;&nbsp;
                <b style={{ fontSize: "larger" }}><ReloadOutlined spin={global.ws["closing"]} onClick={() => {
                    global.ws.close();
                    openNotificationWithIcon(true, `Reconnecting ...`);
                }}/></b> &nbsp;&nbsp;
                <b>Update</b>: {this.props.data.updatedAt ? new Date(this.props.data.updatedAt).toTimeString().substring(0, 8) : ""} &nbsp;
                <b>Send</b>: {this.props.data.sendAt ? new Date(this.props.data.sendAt).toTimeString().substring(0, 8) : ""} &nbsp;
                <b>Render</b>: {new Date().toTimeString().substring(0, 8)}
            </div>
            <div style={{ marginTop: "55px", overflowX: "auto" }}>
                <Table bordered striped hover responsive>{this.buildTableBody()}</Table>
            </div>

            <Row style={{ textAlign: "center" }}>
                {this.props.data.manual ?
                    <ManualTable data={this.props.data.manual}
                                 tabName={this.props.tabName}
                                 tableName={this.props.accountName}
                                 portfolio={this.props.portfolio}
                    /> : ""}
            </Row>
        </Row>);
    }
}

class TableTab extends React.Component {
    render () {
        let tables;
        if (typeof (this.props.config) === "string") {
            let accountName = this.props.config;
            return (
                <div hidden={this.props.activeKey !== this.props.tabName}>
                    <Grid fluid={true}>
                        <Row>
                            <AccountTable key={accountName}
                                          data={accountName}
                                          tabName={this.props.tabName}
                                          accountName={accountName}
                                          portfolio={this.props.portfolio}/>
                        </Row>
                    </Grid>
                </div>
            );
        }
        else {
            tables = Object.keys(this.props.config);
        }
        return (
            <div hidden={this.props.activeKey !== this.props.tabName}>
                <Grid fluid={true}>
                    <Row>
                        {tables.map((accountName) => {
                            if (this.props.config[accountName].length !== 0) return ( // 不渲染 Config 里没有配置信息的 Table
                                <AccountTable key={accountName}
                                              data={this.props.data[accountName]}
                                              tabName={this.props.tabName}
                                              accountName={accountName}
                                              portfolio={this.props.portfolio}/>
                            );
                            // return accountName;
                        })}
                    </Row>
                </Grid>
            </div>
        );
    }
}

/**
 * main component
 */
class PortfolioMonitor extends React.Component {
    constructor (props) {
        // console.log('what-------------------')
        super(props);
        this.state = {
            data: undefined,
            init: {},
            tableElement: {},
            lastModify: Date.now(),
            config: "",
            activeKey: "ActSum",
            changed: false,
            dynamicData: {},
            dynamicDataReceived: {},
            startReceiveDynamicData: {},
            activePair: "",
            pairChanged: false,
            portfolio: defaultPortfolio,
            firstStepPair: "",
            firstColumnPair: "",
            cleaning: false,
            errMsg: "",
            errCount: 0
        };
        this.resetTime = Date.now();
        this.updateIdMap = new Map();

        if (!CheckFrequencyInterval) {
            CheckFrequencyInterval = setInterval(() => this.checkUpdateFrequency(), 5000);
        }

        if (!CleanHeapInterval) {
            CleanHeapInterval = setInterval(() => {
                try {
                    const heapSize = window.performance["memory"]["totalJSHeapSize"] / 1000000;

                    if (heapSize > 1000) {
                        console.log(`${new Date().toLocaleString()}: heap size ${heapSize.toFixed(0)}MB, cleaning heap...`);
                        // this.initTableStructure();
                        // this.sendSnapshotRequest();

                        this.setState({ cleaning: true });
                        setTimeout(() => {
                            this.setState({ cleaning: false });
                            const heapSize = window.performance["memory"]["totalJSHeapSize"] / 1000000;
                            console.log(`${new Date().toLocaleString()}: heap size decrease to ${heapSize.toFixed(0)}MB.`);
                        }, 3000);
                    }
                } catch (e) {
                    // when safari not support window.performance['memory']
                    if (Date.now() - this.resetTime > 60 * 60000) {
                        console.log(`${new Date().toLocaleString()}: [Safari] cleaning heap every hour...`);

                        this.resetTime = Date.now();
                        this.setState({ cleaning: true });
                        setTimeout(() => this.setState({ cleaning: false }), 3000);
                    }
                }
            }, 5 * 60000);
        }

        // setInterval(() => {
        //     console.log(JSON.stringify(this.state.data).length)
        // }, 10000)
    }

    checkUpdateFrequency () {
        if (global.updateFrequency !== UPDATE_INTERVAL) {
            UPDATE_INTERVAL = global.updateFrequency;
            clearInterval(this.timerID);
            this.timerID = setInterval(() => this.setStateWithChanged(), UPDATE_INTERVAL);

            if (this.ws && this.ws.readyState === WebSocket.OPEN) {
                this.ws.send(JSON.stringify({ update_interval: UPDATE_INTERVAL }));
            }
        }
    }

    refresh () {
        if (this.is_refreshing === true) {
            return;
        }
        this.is_refreshing = true;
        this.setState({
            // data: undefined,
            // init: {},
            // tableElement: {},
            lastModify: Date.now(),
            // config: "",
            activeKey: "ActSum",
            changed: false,
            dynamicData: {},
            dynamicDataReceived: {},
            startReceiveDynamicData: {},
            activePair: "",
            firstStepPair: "",
            firstColumnPair: "",
        });
        let path = window.location.hash;
        let permission = JSON.parse(localStorage.getItem("permission"));
        if (!permission || !(path.substr(1, path.length - 1).split("&")[0] in permission)) {
            this.props.history.push("/forbidden");
            return;
        }

        let params = new URLSearchParams(this.props.location.search);
        if (params.has("p") && strategyConfigs.hasOwnProperty(params.get("p"))) {
            this.setState({ portfolio: params.get("p") });
            this.state.portfolio = params.get("p");
        }
        else {
            this.setState({ portfolio: defaultPortfolio });
            this.state.portfolio = defaultPortfolio;
        }
        if (params.has("freq")) {
            UPDATE_INTERVAL = parseInt(params.get("freq"));
        }
        if (this.state.portfolio === "vol") {
            if (localStorage.getItem("username") !== "jesse") {
                this.props.history.push("/forbidden");
                return;
            }
            else {
                this.setState({
                    activeKey: global.defaultTab || "ActSum",
                });
            }
        }

        $.ajax({
            method: "post",
            url: cnf["restUrl"] + "/login",
            timeout: 10000, // sets timeout to 10 seconds
            data: {
                username: localStorage.getItem("username") || "guest",
                password: localStorage.getItem("password") || sessionStorage.getItem("password") || "pass"
            },
            success: (data) => {
                localStorage.setItem("user", JSON.parse(data)["user"]);
                this.setState({ errMsg: "" });
                this.getData();
                this.state.errCount = 0;
            },
            error: (data) => {
                console.log("error data: ", data);
                if (data && data.status === 401) {  // unauthorized
                    this.props.history.push("/login");
                }
                else {
                    console.log(`${new Date().toLocaleString()}: retry to reconnect in 3 seconds...`);
                    this.state.errCount++;

                    this.setState({ errMsg: `${data.statusText} - ${data.status}, reconnect [${this.state.errCount}] in 3 seconds ...` });
                    setTimeout(() => {
                        if (this.state.errCount > 10) {
                            window.location.reload()
                        }
                        else {
                            this.refresh()
                        }
                    }, 3000);
                }
            }
        });

        this.is_refreshing = false;
    }

    formatTableStructure (raw_config, init_value) {
        const config = JSON.parse(JSON.stringify(raw_config));

        for (let tabName of Object.keys(config)) {
            if (tabName === "ActSum") {
                continue;
            }
            this.state.tableElement[tabName] = {};
            for (let tableName of Object.keys(config[tabName])) {
                this.state.tableElement[tabName][tableName] = {};

                if (config[tabName][tableName].rows && config[tabName][tableName].rows[0] && Object.keys(config[tabName][tableName].rows[0])[0]) {
                    let templateRow = config[tabName][tableName].rows[0];
                    let row0 = Object.keys(config[tabName][tableName].rows[0])[0];
                    let templateRowKey = row0.slice(0, row0.lastIndexOf("|"));
                    let templateColumns = Object.keys(templateRow).map(r => r.replace(`${templateRowKey}|`, ""));

                    if (init_value !== undefined) {
                        Object.keys(templateRow).forEach(k => templateRow[k] = init_value);
                    }

                    this.state.tableElement[tabName][tableName]["columns"] = templateColumns;
                    this.state.tableElement[tabName][tableName]["rowKeys"] = [templateRowKey];

                    config[tabName][tableName].rows.forEach((x, i) => {
                        if (+i !== 0 && Object.keys(x).length > 0) {
                            let r0 = Object.keys(config[tabName][tableName].rows[i])[0];
                            let rowKey = r0.slice(0, r0.lastIndexOf("|"));
                            let fullRow = {};
                            templateColumns.forEach(c => {
                                if (config[tabName][tableName].rows[i][`${rowKey}|${c}`] !== undefined) {
                                    fullRow[`${rowKey}|${c}`] = config[tabName][tableName].rows[i][`${rowKey}|${c}`];
                                }
                                else {
                                    fullRow[`${rowKey}|${c}`] = templateRow[`${templateRowKey}|${c}`];
                                }
                            });
                            config[tabName][tableName].rows[i] = fullRow;

                            this.state.tableElement[tabName][tableName]["rowKeys"].push(rowKey);
                        }
                    });

                    this.state.tableElement[tabName][tableName]["rowIndex"] = {};

                    config[tabName][tableName].rows.forEach((x, i) => {
                        Object.keys(x).forEach(k => {
                            this.state.tableElement[tabName][tableName]["rowIndex"][k] = i;
                        });
                    });
                }
            }
        }
        return config;
    }

    initTableStructure () {
        const structure = this.state.init_data;
        this.state.data = JSON.parse(JSON.stringify(structure));

        if (this.tableSyncIntervals) {
            this.tableSyncIntervals.forEach(id => clearInterval(id));
        }

        if (typeof structure === "object") {
            global.DefaultTabOptions = Object.keys(structure);
        }

        Object.keys(structure).forEach((sum_tab) => {
            if (sum_tab.includes("MonitorS")) {
                Object.keys(structure[sum_tab]).forEach((act_table) => {
                    let arr = act_table.split("_");
                    let act = arr.slice(0, 2).join("_");
                    let table = arr.slice(2).join("_");
                    let pm_tab = "PortfolioMonitor_" + act;

                    let key_index_map = {};
                    structure[sum_tab][act_table]["rows"].forEach((e, i) => {
                        if (Object.keys(e)[0].startsWith("|") === false) {
                            let key = Object.keys(e)[0].split("|").slice(0, -1).join("|");
                            let j = structure[pm_tab][table]["rows"].findIndex(x => Object.keys(x)[0].split("|").slice(0, -1).join("|") === key);
                            key_index_map[key] = [i, j];
                        }
                    });

                    // let summarize_monitor_interval = setInterval(() => {
                    if (this.state.data && this.state.data[pm_tab] && this.state.data[pm_tab][table]) {
                        Object.values(key_index_map).forEach(ij => {
                            if (ij[1] > -1) {
                                this.state.data[sum_tab][act_table]["rows"][ij[0]] = this.state.data[pm_tab][table]["rows"][ij[1]];
                            }

                            this.state.data[sum_tab][act_table].latency = this.state.data[pm_tab][table].latency;
                            const tableSyncInterval = setInterval(() => {
                                if (this.state.data && this.state.data[pm_tab] && this.state.data[pm_tab][table]) {
                                    this.state.data[sum_tab][act_table].updatedAt = this.state.data[pm_tab][table].updatedAt;
                                    this.state.data[sum_tab][act_table].sendAt = this.state.data[pm_tab][table].sendAt;
                                    this.state.data[sum_tab][act_table].latency = this.state.data[pm_tab][table].latency;
                                }
                            }, UPDATE_INTERVAL);

                            this.tableSyncIntervals = this.tableSyncIntervals || [];
                            this.tableSyncIntervals.push(tableSyncInterval);
                        });
                        // clearInterval(summarize_monitor_interval);
                    }
                    // }, 500);
                });
            }
        });
    }

    getData () {
        const that = this;
        $.ajax({
            method: "get",
            async: false,
            url: cnf["restUrl"] + "/strategy_status/getConfig/" + strategyConfigs[this.state.portfolio],
            success: (data) => {
                if (data) {
                    const raw_config = typeof data === "string" ? JSON.parse(data) : data;
                    const config = this.formatTableStructure(raw_config);
                    this.state.init_data = this.formatTableStructure(raw_config, "");

                    this.initTableStructure();
                    this.setState({ init: config });
                }
                this.ws = new WebSocket(cnf["websocketUrl"] + "/strategy_status/" + this.state.portfolio);
                this.ws.onopen = () => {
                    console.log(`${new Date().toLocaleString()}: connection open...`);
                    this.ws.closing = false;
                    this.ws.send(JSON.stringify({ update_interval: UPDATE_INTERVAL, username: localStorage.getItem("username") || "guest"}));
                };
                this.ws.onerror = (error) => {
                    console.log("connect error", error);
                };
                this.ws.onclose = () => {
                    console.log(`${new Date().toLocaleString()}: connection close`);
                    if (true === this.disableWSReconnect) {
                        return;
                    }
                    this.ws.closing = true;
                    console.log(`${new Date().toLocaleString()}: connection close`);
                    console.log(`${new Date().toLocaleString()}: reconnecting...`);
                    setTimeout(() => {
                        this.componentWillMount();
                        this.refresh();
                        clearInterval(this.timerID);
                        this.timerID = setInterval(() => {
                            this.setStateWithChanged();
                        }, UPDATE_INTERVAL);
                    }, 500);
                };
                this.ws.onmessage = async (e) => {
                    // console.log(e.data)
                    // console.log(await e.data.text())

                    // let d = zlib.inflateSync((await e.data.text())).toString();
                    // let d = zlib.inflateSync(Buffer.from(await e.data.arrayBuffer())).toString();

                    // let rawData = (typeof d === "string") ? JSON.parse(d) : d;

                    // let rawData = JSON.parse(pako.inflate(new Uint8Array(e.data), {to: 'string'}));

                    let rawData = JSON.parse(e.data);

                    if (rawData["event"] === "snapshot") {
                        console.log(`${new Date().toLocaleString()}: incremental snapshot received.`);
                        this.updateIdMap.set(this.ws, rawData["updateId"]);
                    }
                    else {
                        const lastUpdateId = this.updateIdMap.get(this.ws);

                        if (lastUpdateId === undefined || rawData["updateId"] !== lastUpdateId + 1) {
                            if (this.snapshotting_timeout === undefined) {
                                console.error(`${new Date().toLocaleString()}: incremental update [${rawData["updateId"]}] was lost! re-snapshotting...`);
                                this.snapshotting_timeout = setTimeout(() => {
                                    this.sendSnapshotRequest();
                                    this.snapshotting_timeout = undefined;
                                }, 1000);
                            }
                            else {
                                return;
                            }
                            return;
                        }
                        this.updateIdMap.set(this.ws, rawData["updateId"]);
                    }

                    if (rawData.errMsg) {
                        that.setState({
                            errMsg: rawData.errMsg
                        });
                        return;
                    }
                    that.state.errMsg = null;

                    let tabName = rawData.tabName;
                    let tableName = rawData.tableName;
                    let update_data = rawData.data;

                    if (tabName && tabName.startsWith("DynamicChart")) {
                        if (that.state.data !== undefined) {
                            that.state.data[tabName] = that.state.data[tabName] || {};
                            that.state.data[tabName][tableName] = that.state.data[tabName][tableName] || {};
                            update_data.forEach((e) => {
                                for (let k of Object.keys(e)) {
                                    let [chartName, chartKey] = k.split("|");
                                    that.state.data[tabName][tableName][chartName] = that.state.data[tabName][tableName][chartName] || {};
                                    that.state.data[tabName][tableName][chartName][chartKey] = that.state.data[tabName][tableName][chartName][chartKey] || [];
                                    that.state.dynamicDataReceived[chartName] = true;

                                    // let k_str = `${tabName}|${tableName}|${chartName}|${k}`;
                                    // console.log(that.state.startReceiveDynamicData)
                                    // if (that.state.startReceiveDynamicData[k_str]) {
                                    that.state.data[tabName][tableName][chartName][chartKey].push(e[k]);
                                    // }

                                    while (that.state.data[tabName][tableName][chartName][chartKey].length > max_dynamic_data) {
                                        that.state.data[tabName][tableName][chartName][chartKey].shift();
                                    }
                                }
                            });
                        }
                    }
                    else if (tabName && tabName.startsWith("SpreadChart")) {
                        if (that.state.data !== undefined) {
                            if (that.state.data[tabName] === undefined) {
                                that.state.data[tabName] = {};
                            }
                            if (that.state.data[tabName][tableName] === undefined) {
                                that.state.data[tabName][tableName] = {};
                            }
                            that.state.data[tabName][tableName] = Object.assign(that.state.data[tabName][tableName], update_data);

                            if (this.state.activeKey.includes("SpreadChart") &&
                                (this.state.activePair === tableName || this.state.activePair.split(".")[1] === tableName)) {
                                this.setState({ pairChanged: true });   // force rendering spread chart
                            }
                        }
                    }
                    else if (tabName && tabName.startsWith("CacheChart")) {
                        if (that.state.data !== undefined) {
                            if (that.state.data[tabName] === undefined) {
                                that.state.data[tabName] = {};
                            }
                            if (that.state.data[tabName][tableName] === undefined) {
                                that.state.data[tabName][tableName] = {};
                            }
                            that.state.data[tabName][tableName] = update_data;

                            if (this.state.activeKey.includes("CacheChart") && this.state.activePair === tableName) {
                                this.setState({ pairChanged: true });   // force rendering cache chart
                            }
                        }
                    }
                    else if (tabName && tabName.includes("Chart")) {
                        // chart update_data format: {
                        //      chart_type: 'line',
                        //      data_type: 'price',
                        //      percent: false,
                        //      series_name: ['BTCUSD_price', 'ETHUSD_price'],
                        //      series: [[[16787898900, 12345], [...], ...], [[16787898900, 56789], [...]...]]
                        // }
                        if (that.state.data !== undefined) {
                            if (that.state.data[tabName] === undefined) {
                                that.state.data[tabName] = {};
                            }
                            if (that.state.data[tabName][tableName] === undefined) {
                                that.state.data[tabName][tableName] = {};
                            }
                            that.state.data[tabName][tableName] = update_data;

                            if (this.state.activeKey === tabName && this.state.activePair === tableName) {
                                this.setState({ pairChanged: true });   // force rendering chart
                            }
                        }
                    }
                    else if (tabName && tabName.startsWith("ActSum")) {
                        if (that.state.data[tabName] === undefined) return;
                        if (that.state.data[tabName][tableName] === undefined) return;
                        if (that.state.data[tabName][tableName].rows === undefined) return;

                        that.state.changed = true;

                        that.state.data[tabName][tableName].updatedAt = rawData.updatedAt;
                        that.state.data[tabName][tableName].sendAt = rawData.sendAt;
                        that.state.data[tabName][tableName].latency = rawData.latency;

                        let update_keys = Object.keys(update_data);

                        that.state.data[tabName][tableName].rows.forEach((row, ix) => {
                            Object.keys(row).forEach((rowKey) => {
                                for (const k of update_keys) {
                                    if (k === rowKey) {
                                        that.state.data[tabName][tableName].rows[ix][rowKey] = update_data[rowKey];
                                    }
                                }
                            });
                        });
                    }
                    else if (tabName) {
                        // if (this.state.tableElement[tabName] === undefined || this.state.tableElement[tabName][tableName] === undefined) {
                        //     return;
                        // }
                        if (that.state.data[tabName] === undefined) return;
                        if (that.state.data[tabName][tableName] === undefined) return;
                        if (that.state.data[tabName][tableName].rows === undefined) return;

                        that.state.changed = true;

                        that.state.data[tabName][tableName].updatedAt = rawData.updatedAt;
                        that.state.data[tabName][tableName].sendAt = rawData.sendAt;
                        that.state.data[tabName][tableName].latency = rawData.latency;

                        let update_keys = Object.keys(update_data);

                        for (let i = 0, l = update_keys.length; i < l; i++) {
                            let row_index = that.state.tableElement[tabName][tableName]["rowIndex"][update_keys[i]];
                            if (row_index === undefined || that.state.data[tabName][tableName].rows[row_index] === undefined) {
                                continue;
                            }
                            that.state.data[tabName][tableName].rows[row_index][update_keys[i]] = update_data[update_keys[i]];
                        }

                        // // if (that.state.data[tabName][tableName].tableRows === undefined) {
                        //     that.state.data[tabName][tableName].tableRows = [];
                        // // }
                        // that.state.data[tabName][tableName].rows.forEach((row, ix) => {
                        //     if (that.state.data[tabName][tableName].tableRows[ix] === undefined) {
                        //         that.state.data[tabName][tableName].tableRows[ix] = {};
                        //     }
                        //     let row_key = that.state.tableElement[tabName][tableName]['rowKeys'][ix];
                        //
                        //     if (row_key === '') {
                        //         that.state.data[tabName][tableName].tableRows[ix]["rowKey"] = ''.padStart(ix, ' ');
                        //     }
                        //     else {
                        //         that.state.data[tabName][tableName].tableRows[ix]['rowKey'] = row_key;
                        //     }
                        //
                        //     that.state.tableElement[tabName][tableName]['columns'].forEach((col) => {
                        //         that.state.data[tabName][tableName].tableRows[ix][col] = row[`${row_key}|${col}`];
                        //     })
                        // });
                    }
                };

                global.ws = this.ws;
            },
            error: (data) => {
                console.log(data);
            }
        });
    }

    componentWillMount () {
        this.logout = this.logout.bind(this);
    }

    setStateWithChanged () {
        // Note: force to render for detecting out-dated data stream
        if (this.state.activeKey.includes("Chart") === false) {
            this.setState({ changed: false });
        }
    }

    shouldComponentUpdate (nextProps, nextState) {
        if (nextState.activeKey.startsWith("StepChart")) {
            if (this.state.firstStepPair === "" && nextState.activePair !== "" && nextState.pairChanged === true) {
                if (nextState.activePair.includes("next_rate")) {
                    nextState.firstStepPair = nextState.activePair;
                    // NOTE: solve initial active pair data override bug
                    let re_fetch_interval = setInterval(() => {
                        if (this.state.activePair !== this.state.firstStepPair) {
                            this.fetch_step_chart_data(nextState.activeKey, nextState.activePair, 5 * 60000);
                            clearInterval(re_fetch_interval);
                        }
                    }, 500);
                }
            }
        }

        if (nextState.activePair !== "" && nextState.pairChanged === false) {
            if (nextState.activeKey.includes("Chart")) {
                return false;
            }
        }
        else if (nextState.activePair !== "" && nextState.pairChanged === true) {
            if (nextState.activeKey.includes("Chart")) {
                this.state.pairChanged = false;
                return true;
            }
        }

        return true;
    }

    componentWillUnmount () {
        this.closeWs();
        clearInterval(this.timerID);
    }

    closeWs () {
        if (this.ws) {
            this.disableWSReconnect = true;
            this.ws.close();
            this.ws = null;
        }
    }

    componentDidMount () {
        this.refresh();
        this.timerID = setInterval(() => {
            // Note: force to render for detecting out-dated data stream
            // if (this.state.changed === true) {
            this.setStateWithChanged();
            // }
        }, UPDATE_INTERVAL);

        setInterval(() => {
            if (this.ws) {
                if (this.ws.readyState === WebSocket.OPEN) {
                    this.ws.send("ping");
                }
                else if (this.ws.readyState === WebSocket.CLOSED) {
                    this.ws.close();
                }
            }
        }, 15000);
    }

    logout (e) {
        e.preventDefault();
        this.props.history.push("/login");
    }

    handleSelect (k) {
        let that = this;

        if (this.ws && this.ws.readyState === 1) {
            if (k.includes("MonitorS")) {
                let acts = Array.from(new Set(Object.keys(this.state.init[k]).map(i => i.split("_").slice(0, 2).join("_"))));
                let aks = acts.map(act => "PortfolioMonitor_" + act);
                this.ws.send(JSON.stringify({ activeKey: aks }));
                // this.ws.send(JSON.stringify({activeKey: Object.keys(this.state.init).filter(x => x.includes('PortfolioMonitor'))}));
            }
            else {
                this.ws.send(JSON.stringify({ activeKey: k }));
            }
        }
        this.setState({ activeKey: k, activePair: "" });

        if (k.includes("StepChart")) {
            /**
             tableNames = [
             {
             FundingRates@7D: [
             "BinanceC.BTCUSD.perp.rate",
             "BinanceC.ETHUSD.perp.rate",
             "BinanceC.BNBUSD.perp.rate"
             ]
             },
             "BinanceC.BTCUSD.perp.next_rate",
             "BinanceC.ETHUSD.perp.next_rate",
             "BinanceC.BNBUSD.perp.next_rate",
             "BinanceU.BTCUSDT.perp.next_rate",
             "BinanceU.ETHUSDT.perp.next_rate",
             "BinanceU.BNBUSDT.perp.next_rate"
             }]
             * */
            Object.keys(this.state.init[k]).forEach(tableName => {
                if (that.state.data === undefined) {
                    that.state.data = {};
                }
                if (that.state.data[k] === undefined) {
                    that.state.data[k] = {};
                }
                if (that.state.data[k][tableName] === undefined) {
                    that.state.data[k][tableName] = {};
                }
                if (that.state.data[k][tableName]["step"] === undefined) {
                    this.fetchStepChartData(k, tableName);
                }

                if (tableName.includes("next_rate")) {
                    this.state.firstStepPair = "";
                }
            });
        }
    }

    sendSnapshotRequest () {
        this.ws.send(JSON.stringify({ snapshot: true }));
    }

    handleChangePair (option) {
        const { activePair } = this.state;

        if (typeof option !== "object") {
            option = { value: option };
        }
        if (option === undefined) {
            option = { value: undefined };
        }
        let changed = (option && option.value !== activePair);
        this.setState({ activePair: option.value, pairChanged: changed });

        if (this.state.activeKey.includes("StepChart")) {
            if (this.state.data[this.state.activeKey] === undefined) {
                this.state.data[this.state.activeKey] = {};
            }
            if (this.state.data[this.state.activeKey][option.value] === undefined) {
                this.state.data[this.state.activeKey][option.value] = {};
            }
            this.fetchStepChartData(this.state.activeKey, option.value);
        }

        if (this.ws && this.ws.readyState === 1) {
            this.ws.send(JSON.stringify({ activeKey: this.state.activeKey, activePair: option.value }));

            // if (this.state.activeKey.includes('SpreadChart')) {
            //     const symbol = option.value.split('.')[1];
            //     this.ws.send(JSON.stringify({activeKey: this.state.activeKey, activePair: symbol}));
            // }
        }
    }

    /**
     * StepChartDataDemo = {
     *     data: {
     *         step: {
     *             [
     *                 1234567890123, 0.0001,
     *                 1234567950123, 0.0001,
     *                 1234568010123, 0.0001,
     *             ]
     *         }
     *     },
     *     tableName: "BinanceU.BTCUSDT.perp.rate",
     *     tabName: "StepChart_ACT_FDA"
     * }
     * */

    fetchStepChartData (tabName, tableName) {
        let that = this;
        let timeout = 5 * 60000;
        if (tableName.startsWith("FundingRate")) {
            timeout = 60000 * 60;
        }
        if (that.state.data[tabName][tableName]["step"] === undefined ||
            Date.now() > that.state.data[tabName][tableName]["step_next_update_ts"]) {
            this.fetch_step_chart_data(tabName, tableName, timeout);
        }
    }

    fetch_step_chart_data (tabName, tableName, timeout) {
        let that = this;

        let body;
        if (tableName.startsWith("FundingRate")) {
            body = {};
            body[tableName] = that.state.init[tabName][tableName]["charts"];
        }
        else if (tableName.includes(".") && tableName.startsWith("-") === false) {
            body = tableName;
        }
        else {
            return;
        }

        $.ajax({
            method: "post",
            url: cnf["restUrl"] + "/step_chart",
            data: {
                url: JSON.stringify(body),
            },
            success: (data) => {
                if (data) {
                    // console.log(cnf['api'] + '/step_chart');
                    // console.log(tabName, tableName)
                    // if (that.state.activePair === tableName) {
                    that.state.data[tabName][tableName]["step"] = data; // [[next_rate],[price]]
                    that.state.data[tabName][tableName]["step_next_update_ts"] = Date.now() + timeout;

                    // if (that.state.activeKey.includes('StepChart') && that.state.activePair === tableName) {
                    //     that.setState({pairChanged: true});   // force to render spread chart
                    // }
                    // }
                }
            },
            error: (err) => {
                console.log("error occurred:", err);
            }
        });
    }

    ts_formatter (ts) {
        const date = new Date(ts);
        let yyyy = date.getFullYear();
        let MM = date.getMonth();
        let dd = date.getDate();
        let hh = date.getHours();
        let mm = date.getMinutes();
        let ss = date.getSeconds();

        MM = MM < 9 ? `0${MM + 1}` : (MM + 1);
        dd = dd < 10 ? `0${dd}` : dd;
        hh = hh < 10 ? `0${hh}` : hh;
        mm = mm < 10 ? `0${mm}` : mm;
        ss = ss < 10 ? `0${ss}` : ss;

        return `${yyyy}-${MM}-${dd} ${hh}:${mm}:${ss}`;
    }

    renderSelector (options) {
        let that = this;
        let Options = [];
        for (let o of options) {
            Options.push({ value: o, label: o });
        }

        const width = Math.max(Math.max(...options.map(o => o.length)) * 11, 350) + "px";

        return (
            <div className={"pnl-tab"}>
                <Form inline style={{ width: width, "paddingTop": "30px", "margin": "auto" }}>
                    <Select name={"chart_pair_selector"}
                            maxTagCount={15}
                            listHeight={400}
                            autoFocus={true}
                            style={{ width: width, "margin": "auto" }}
                            placeholder={"please select"}
                            value={that.state.activePair || "please select"}
                            onChange={(o) => this.handleChangePair(o)}
                            options={Options}>
                    </Select>
                </Form>
            </div>
        );
    }

    renderLoadingStatus () {
        return (<div align="center">
            <Spin key={"loading_spin"} style={{ paddingTop: "350px" }} size="medium" tip="Loading Data.."/>
        </div>);
    }

    renderChart (tabName) {
        let that = this;

        function getLineChartOption (tabName, tableName) {
            const names = that.state.data[tabName][tableName]["series_name"];
            const data_type = that.state.data[tabName][tableName]["data_type"];
            const in_pct = that.state.data[tabName][tableName]["percent"];
            const series = that.state.data[tabName][tableName]["series"].map((points, index) => {
                return {
                    type: names.length === 1 ? "area" : "line",
                    name: names[index],
                    data: points
                };
            });

            return {
                chart: {
                    zoomType: isPC() ? "x" : undefined,
                    height: (Math.min(window.innerWidth, window.innerHeight) < 1000 && window.innerHeight > window.innerWidth) ? "60%" : "35%"
                },
                title: {
                    text: tableName
                },
                credits: {
                    enabled: false
                },
                time: {
                    useUTC: false
                },
                xAxis: {
                    type: "datetime",
                    crosshair: true
                },
                yAxis: {
                    title: {
                        text: data_type
                    },
                    labels: {
                        formatter: function () {
                            return in_pct ? (this.value * 100).toFixed(2) + "%" : this.value;
                        }
                    },
                },
                legend: {
                    enabled: true
                },
                series: series,
                tooltip: {
                    split: true,
                    xDateFormat: "%Y-%m-%d %H:%M:%S",
                    pointFormatter: in_pct ? function () {
                        return "<span style=\"color:" + this.color + "\"> ● </span>"
                            + "<b>" + this.series.name + "</b>: "
                            + (in_pct ? (this.y * 100).toFixed(3) + "%" : this.y);
                    } : undefined
                },
                plotOptions: {
                    area: {
                        fillColor: {
                            linearGradient: {
                                x1: 0,
                                y1: 0,
                                x2: 0,
                                y2: 1
                            },
                            stops: [
                                [0, "#7cb5ec"],
                                [1, "rgba(124, 181, 236, 0)"]
                            ]
                        },
                        marker: {
                            radius: 2
                        },
                        lineWidth: 1,
                        states: {
                            hover: {
                                lineWidth: 1
                            }
                        },
                        threshold: null
                    },
                    line: {
                        threshold: null
                    }
                },
            };
        }

        function getStepChartOption (tabName, tableName) {
            const name = tableName.split("->").slice(-1)[0];
            const points = that.state.data[tabName][tableName];
            const in_pct = typeof points[0][1] === "string";

            return {
                chart: {
                    zoomType: isPC() ? "x" : undefined,
                    height: (Math.min(window.innerWidth, window.innerHeight) < 1000 && window.innerHeight > window.innerWidth) ? "60%" : "35%"
                },
                title: {
                    text: tableName
                },
                credits: {
                    enabled: false
                },
                time: {
                    useUTC: false
                },
                xAxis: {
                    type: "datetime",
                    crosshair: true
                },
                yAxis: [{
                    title: {
                        text: name
                    },
                    labels: {
                        formatter: function () {
                            return in_pct ? (this.value * 100).toFixed(2) + "%" : this.value;
                        }
                    },
                    // minPadding: 0.00,
                    // maxPadding: 0.00
                }],
                legend: {
                    enabled: true
                },
                series: [{
                    type: "area",
                    name: name,
                    data: in_pct ? points.map(i => [i[0], +i[1]]) : points,
                    yAxis: 0
                }],
                tooltip: {
                    split: true,
                    xDateFormat: "%Y-%m-%d %H:%M:%S",
                    pointFormatter: function () {
                        return "<span style=\"color:" + this.color + "\"> ● </span>"
                            + "<b>" + this.series.name + "</b>: "
                            + (in_pct ? (this.y * 100).toFixed(3) + "%" : this.y);
                    }
                },
                plotOptions: {
                    area: {
                        fillColor: {
                            linearGradient: {
                                x1: 0,
                                y1: 0,
                                x2: 0,
                                y2: 1
                            },
                            stops: [
                                [0, "#7cb5ec"],
                                [1, "rgba(124, 181, 236, 0)"]
                            ]
                        },
                        marker: {
                            radius: 2
                        },
                        lineWidth: 1,
                        states: {
                            hover: {
                                lineWidth: 1
                            }
                        },
                        threshold: null
                    },
                    line: {
                        threshold: null
                    }
                },
            };
        }

        function getKlineChartOption (tabName, tableName) {
            const name = tableName.split("->").slice(-1)[0];
            const points = that.state.data[tabName][tableName];
            const in_pct = typeof points[0][1] === "string";

            return {
                chart: {
                    zoomType: isPC() ? "x" : undefined,
                    height: (Math.min(window.innerWidth, window.innerHeight) < 1000 && window.innerHeight > window.innerWidth) ? "60%" : "35%"
                },
                title: {
                    text: tableName
                },
                credits: {
                    enabled: false
                },
                time: {
                    useUTC: false
                },
                xAxis: {
                    type: "datetime",
                    crosshair: true
                },
                yAxis: [{
                    title: {
                        text: name
                    },
                    labels: {
                        formatter: function () {
                            return in_pct ? (this.value * 100).toFixed(2) + "%" : this.value;
                        }
                    },
                    // minPadding: 0.00,
                    // maxPadding: 0.00
                }],
                legend: {
                    enabled: true
                },
                series: [{
                    type: "area",
                    name: name,
                    data: in_pct ? points.map(i => [i[0], +i[1]]) : points,
                    yAxis: 0
                }],
                tooltip: {
                    split: true,
                    xDateFormat: "%Y-%m-%d %H:%M:%S",
                    pointFormatter: function () {
                        return "<span style=\"color:" + this.color + "\"> ● </span>"
                            + "<b>" + this.series.name + "</b>: "
                            + (in_pct ? (this.y * 100).toFixed(3) + "%" : this.y);
                    }
                },
                plotOptions: {
                    area: {
                        fillColor: {
                            linearGradient: {
                                x1: 0,
                                y1: 0,
                                x2: 0,
                                y2: 1
                            },
                            stops: [
                                [0, "#7cb5ec"],
                                [1, "rgba(124, 181, 236, 0)"]
                            ]
                        },
                        marker: {
                            radius: 2
                        },
                        lineWidth: 1,
                        states: {
                            hover: {
                                lineWidth: 1
                            }
                        },
                        threshold: null
                    },
                    line: {
                        threshold: null
                    }
                },
            };
        }

        function getPieChartOption (tabName, tableName) {
            const name = tableName.split("->").slice(-1)[0];
            const points = that.state.data[tabName][tableName];
            const in_pct = typeof points[0][1] === "string";

            return {
                chart: {
                    zoomType: isPC() ? "x" : undefined,
                    height: (Math.min(window.innerWidth, window.innerHeight) < 1000 && window.innerHeight > window.innerWidth) ? "60%" : "35%"
                },
                title: {
                    text: tableName
                },
                credits: {
                    enabled: false
                },
                time: {
                    useUTC: false
                },
                xAxis: {
                    type: "datetime",
                    crosshair: true
                },
                yAxis: [{
                    title: {
                        text: name
                    },
                    labels: {
                        formatter: function () {
                            return in_pct ? (this.value * 100).toFixed(2) + "%" : this.value;
                        }
                    },
                    // minPadding: 0.00,
                    // maxPadding: 0.00
                }],
                legend: {
                    enabled: true
                },
                series: [{
                    type: "area",
                    name: name,
                    data: in_pct ? points.map(i => [i[0], +i[1]]) : points,
                    yAxis: 0
                }],
                tooltip: {
                    split: true,
                    xDateFormat: "%Y-%m-%d %H:%M:%S",
                    pointFormatter: function () {
                        return "<span style=\"color:" + this.color + "\"> ● </span>"
                            + "<b>" + this.series.name + "</b>: "
                            + (in_pct ? (this.y * 100).toFixed(3) + "%" : this.y);
                    }
                },
                plotOptions: {
                    area: {
                        fillColor: {
                            linearGradient: {
                                x1: 0,
                                y1: 0,
                                x2: 0,
                                y2: 1
                            },
                            stops: [
                                [0, "#7cb5ec"],
                                [1, "rgba(124, 181, 236, 0)"]
                            ]
                        },
                        marker: {
                            radius: 2
                        },
                        lineWidth: 1,
                        states: {
                            hover: {
                                lineWidth: 1
                            }
                        },
                        threshold: null
                    },
                    line: {
                        threshold: null
                    }
                },
            };
        }

        function getDynamicChartOption (tabName, tableName) {
            const name = tableName.split("->").slice(-1)[0];
            const points = that.state.data[tabName][tableName];
            const in_pct = typeof points[0][1] === "string";

            return {
                chart: {
                    zoomType: isPC() ? "x" : undefined,
                    height: (Math.min(window.innerWidth, window.innerHeight) < 1000 && window.innerHeight > window.innerWidth) ? "60%" : "35%"
                },
                title: {
                    text: tableName
                },
                credits: {
                    enabled: false
                },
                time: {
                    useUTC: false
                },
                xAxis: {
                    type: "datetime",
                    crosshair: true
                },
                yAxis: [{
                    title: {
                        text: name
                    },
                    labels: {
                        formatter: function () {
                            return in_pct ? (this.value * 100).toFixed(2) + "%" : this.value;
                        }
                    },
                    // minPadding: 0.00,
                    // maxPadding: 0.00
                }],
                legend: {
                    enabled: true
                },
                series: [{
                    type: "area",
                    name: name,
                    data: in_pct ? points.map(i => [i[0], +i[1]]) : points,
                    yAxis: 0
                }],
                tooltip: {
                    split: true,
                    xDateFormat: "%Y-%m-%d %H:%M:%S",
                    pointFormatter: function () {
                        return "<span style=\"color:" + this.color + "\"> ● </span>"
                            + "<b>" + this.series.name + "</b>: "
                            + (in_pct ? (this.y * 100).toFixed(3) + "%" : this.y);
                    }
                },
                plotOptions: {
                    area: {
                        fillColor: {
                            linearGradient: {
                                x1: 0,
                                y1: 0,
                                x2: 0,
                                y2: 1
                            },
                            stops: [
                                [0, "#7cb5ec"],
                                [1, "rgba(124, 181, 236, 0)"]
                            ]
                        },
                        marker: {
                            radius: 2
                        },
                        lineWidth: 1,
                        states: {
                            hover: {
                                lineWidth: 1
                            }
                        },
                        threshold: null
                    },
                    line: {
                        threshold: null
                    }
                },
            };
        }

        function renderTargetChart (tabName, tableName) {
            if (that.state.data[tabName] === undefined) {
                return that.renderLoadingStatus();
            }
            if (that.state.data[tabName][tableName] === undefined) {
                return that.renderLoadingStatus();
            }
            // if (that.state.data[tabName][tableName]['data'].length === 0) {
            //     return getLoadingStatus();
            // }

            let config = {};
            switch (that.state.data[tabName][tableName]["chart_type"]) {
                case "line":
                    config = getLineChartOption(tabName, tableName);
                    break;
                case "kline":
                    config = getKlineChartOption(tabName, tableName);
                    break;
                case "step":
                    config = getStepChartOption(tabName, tableName);
                    break;
                case "pie":
                    config = getPieChartOption(tabName, tableName);
                    break;
                case "dynamic":
                    config = getDynamicChartOption(tabName, tableName);
                    break;
                default:
                    return null;
            }

            return (
                <Row>
                    <div style={{
                        width: "90%",
                        paddingRight: "0%",
                        paddingTop: "20px",
                        margin: "auto",
                        marginTop: "50px",
                        zoom: 100 / (global.pageZoom || 100)
                    }}>
                        <ReactHighcharts config={config} ref="chart"/>
                    </div>
                </Row>
            );
        }

        const pairs = Object.keys(this.state.init[tabName]);

        return (
            <div key={tabName + "_chart"} hidden={this.state.activeKey !== tabName}>
                {that.renderSelector(pairs)}
                {pairs.filter((pair) => pair === that.state.activePair).map((tableName) => {
                    return (renderTargetChart(tabName, tableName));
                })}
            </div>
        );
    }

    renderSpreadChart (tabName) {
        let that = this;
        if (that.state.data[tabName] === undefined) {
            return that.renderLoadingStatus();
        }

        function processPoints (tableName, key) {
            let points = [];

            if (that.state.data[tabName][tableName] && that.state.data[tabName][tableName][key]) {
                let raw_data = that.state.data[tabName][tableName][key];
                let data_particle = raw_data[1];
                let data_length = raw_data.length - 2;
                raw_data.slice(2 - raw_data.length).forEach((e, i) => {
                    let ts = Math.floor(raw_data[0] / data_particle) * data_particle - data_particle * (data_length - i - 1);
                    points[i] = [ts, e];
                });
            }

            return points;
        }

        function getSpreadChartOption (tabName, tableName) {
            let symbol = that.state.data[tabName][tableName]["symbol"];
            let spread_type = that.state.data[tabName][tableName]["spread_type"] || "percent";

            // let spread_points = processPoints(tableName, 'spread');
            // let price_points = processPoints(symbol, 'price');

            let spread_points = that.state.data[tabName][tableName]["spread"];
            let price_points = that.state.data[tabName][tableName]["price"];

            // let price_points = [];
            // if (that.state.data[tabName][symbol] && that.state.data[tabName][symbol]['price']) {
            //     price_points = that.state.data[tabName][symbol]['price'];
            // }

            let spread_send_ts = new Date(that.state.data[tabName][tableName]["timestamp"]).toLocaleString();

            return {
                chart: {
                    zoomType: isPC() ? "x" : undefined,
                    height: (Math.min(window.innerWidth, window.innerHeight) < 1000 && window.innerHeight > window.innerWidth) ? "60%" : "35%"
                },
                title: {
                    text: tableName
                },
                subtitle: {
                    text: "data update time: " + spread_send_ts
                },
                credits: {
                    enabled: false
                },
                time: {
                    useUTC: false
                },
                xAxis: {
                    type: "datetime",
                    crosshair: true
                },
                yAxis: [{
                    title: {
                        text: "Spread"
                    },
                    labels: {
                        formatter: function () {
                            return (spread_type === "percent") ? ((this.value * 100).toFixed(2) + "%") : this.value;
                        }
                    },
                    minPadding: 0.00,
                    maxPadding: 0.00
                }, {
                    opposite: true,
                    title: {
                        text: "Price: " + symbol
                    },
                    labels: {
                        formatter: function () {
                            return this.value.toString();
                        }
                    },
                    minPadding: 0.0,
                    maxPadding: 0.0
                }],
                legend: {
                    enabled: true
                },
                series: [{
                    type: "area",
                    name: "Spread",
                    data: spread_points,
                    yAxis: 0
                }, {
                    type: "line",
                    name: "Price",
                    data: price_points,
                    yAxis: 1
                }],
                tooltip: {
                    split: true,
                    formatter: function () {
                        return ["<b>" + that.ts_formatter(this.x) + "</b>"].concat(
                            this.points ? this.points.map(point => "<span style=\"color:" + point.color + "\"> ● </span>"
                                + "<b>" + point.series.name + "</b>: "
                                + ((point.series.name === "Spread" && spread_type === "percent") ? ((point.y * 100).toFixed(2) + "%") : point.y)) : []
                        );
                    },
                    // xDateFormat: '%Y-%m-%d %H:%M:%S',
                    // pointFormatter: function () {
                    //     return '<span style="color:' + this.color + '"> ● </span>'
                    //         + '<b>' + this.series.name + '</b>: '
                    //         + (this.series.name === 'Spread' ? ((this.y * 100).toFixed(2) + '%') : this.y)
                    // }
                },
                plotOptions: {
                    area: {
                        fillColor: {
                            linearGradient: {
                                x1: 0,
                                y1: 0,
                                x2: 0,
                                y2: 1
                            },
                            stops: [
                                [0, "#7cb5ec"],
                                [1, "rgba(124, 181, 236, 0)"]
                            ]
                        },
                        marker: {
                            radius: 2
                        },
                        lineWidth: 1,
                        states: {
                            hover: {
                                lineWidth: 1
                            }
                        },
                        threshold: null
                    },
                    line: {
                        threshold: null
                    }
                },
            };
        }

        function getDistChartOption (tabName, tableName) {
            let data = that.state.data[tabName][tableName]["dist"];
            let lvls = data["lvls"];
            let enter_dist = data["enter_dist"];
            let exit_dist = data["exit_dist"];
            let enter_size_sum = enter_dist.reduce((a, b) => a + b, 0);
            let exit_size_sum = exit_dist.reduce((a, b) => a + b, 0);

            return {
                chart: {
                    type: "bar",
                    height: lvls.length > 40 ? "60%" : (lvls.length > 30 ? "50%" : (lvls.length > 20 ? "40%" : "30%"))
                },
                title: {
                    text: tableName
                },
                subtitle: {
                    text: "Spread Execution Distribution"
                },
                credits: {
                    enabled: false
                },
                xAxis: [{
                    categories: lvls,
                    reversed: false,
                    labels: {
                        step: 1
                    }
                }, { // mirror axis on right side
                    opposite: true,
                    reversed: false,
                    categories: lvls,
                    linkedTo: 0,
                    labels: {
                        step: 1
                    }
                }],
                yAxis: {
                    title: {
                        text: null
                    },
                    labels: {
                        formatter: function () {
                            return (100 * this.value / (this.value > 0 ? exit_size_sum : enter_size_sum)).toFixed(1) + "%";
                        }
                    }
                },
                plotOptions: {
                    series: {
                        stacking: "normal"
                    }
                },
                tooltip: {
                    formatter: function () {
                        return "<b>" + this.series.name + " range " + this.point.category + "%</b><br/>" +
                            "Executed Size: " + roundPrecision(Math.abs(this.point.y), 2);
                    }
                },
                series: [{
                    name: "Enter",
                    data: enter_dist,
                }, {
                    name: "Exit",
                    data: exit_dist,
                }]
            };
        }

        function renderSingleChart (tabName, tableName) {
            if (that.state.data[tabName][tableName].length === 0) {
                return that.renderLoadingStatus();
            }
            if (that.state.data[tabName][tableName]["spread"] === undefined) {
                return that.renderLoadingStatus();
            }
            return (
                <Row>
                    {that.state.data[tabName][tableName]["spread"] && <div style={{
                        width: "90%",
                        paddingRight: "0%",
                        paddingTop: "20px",
                        margin: "auto",
                        marginTop: "50px"
                    }}>
                        <ReactHighcharts config={getSpreadChartOption(tabName, tableName)} ref="chart"/>
                    </div>}
                    {that.state.data[tabName][tableName]["dist"] && <div style={{
                        width: "90%",
                        paddingRight: "0%",
                        paddingTop: "20px",
                        margin: "auto",
                        marginTop: "50px",
                        zoom: 100 / (global.pageZoom || 100)
                    }}>
                        <ReactHighcharts config={getDistChartOption(tabName, tableName)} ref="chart"/>
                    </div>}
                </Row>
            );
        }

        let pairs = Object.keys(this.state.init[tabName]);

        return (
            <div key={tabName + "_spread_chart"} hidden={this.state.activeKey !== tabName}>
                {that.renderSelector(pairs)}
                {pairs.filter((pair) => pair === that.state.activePair).map((tableName) => {
                    return (renderSingleChart(tabName, tableName));
                })}
            </div>
        );
    }

    renderCacheChart (tabName) {
        let that = this;
        if (that.state.data[tabName] === undefined) {
            return that.renderLoadingStatus();
        }

        function getCacheChartOption (tabName, tableName) {
            const name = tableName.split("->").slice(-1)[0];
            const points = that.state.data[tabName][tableName];
            const in_pct = typeof points[0][1] === "string";

            // (function(H) {
            //     H.wrap(H.Pointer.prototype, 'normalize', function(proceed) {
            //         var e = arguments[1],
            //             chartPosition = arguments[2],
            //             ePos,
            //             containerSize = this.chart.container.clientWidth;
            //
            //         ePos = e.touches ?
            //             (e.touches.length ? e.touches.item(0) : e.changedTouches[0]) :
            //             e;
            //
            //         if (!chartPosition) {
            //             this.chartPosition = chartPosition = H.offset(this.chart.container);
            //         }
            //
            //         return H.extend(e, {
            //             chartX: Math.round(ePos.pageX/0.6  - containerSize * 0.01 - chartPosition.left ),
            //             chartY: Math.round(ePos.pageY/0.6 - chartPosition.top)
            //         });
            //     });
            // })(ReactHighcharts);

            return {
                chart: {
                    zoomType: isPC() ? "x" : undefined,
                    height: (Math.min(window.innerWidth, window.innerHeight) < 1000 && window.innerHeight > window.innerWidth) ? "60%" : "35%"
                },
                title: {
                    text: tableName
                },
                credits: {
                    enabled: false
                },
                time: {
                    useUTC: false
                },
                xAxis: {
                    type: "datetime",
                    crosshair: true
                },
                yAxis: [{
                    title: {
                        text: name
                    },
                    labels: {
                        formatter: function () {
                            return in_pct ? (this.value * 100).toFixed(2) + "%" : this.value;
                        }
                    },
                    // minPadding: 0.00,
                    // maxPadding: 0.00
                }],
                legend: {
                    enabled: true
                },
                series: [{
                    type: "area",
                    name: name,
                    data: in_pct ? points.map(i => [i[0], +i[1]]) : points,
                    yAxis: 0
                }],
                tooltip: {
                    split: true,
                    xDateFormat: "%Y-%m-%d %H:%M:%S",
                    pointFormatter: in_pct ? function () {
                        return "<span style=\"color:" + this.color + "\"> ● </span>"
                            + "<b>" + this.series.name + "</b>: "
                            + (in_pct ? (this.y * 100).toFixed(3) + "%" : this.y);
                    } : undefined
                },
                plotOptions: {
                    area: {
                        fillColor: {
                            linearGradient: {
                                x1: 0,
                                y1: 0,
                                x2: 0,
                                y2: 1
                            },
                            stops: [
                                [0, "#7cb5ec"],
                                [1, "rgba(124, 181, 236, 0)"]
                            ]
                        },
                        marker: {
                            radius: 2
                        },
                        lineWidth: 1,
                        states: {
                            hover: {
                                lineWidth: 1
                            }
                        },
                        threshold: null
                    },
                    line: {
                        threshold: null
                    }
                },
            };
        }

        function renderSingleChart (tabName, tableName) {
            if (that.state.data[tabName][tableName].length === 0) {
                return that.renderLoadingStatus();
            }
            if (that.state.data[tabName][tableName] === undefined) {
                return that.renderLoadingStatus();
            }
            return (
                <Row>
                    {that.state.data[tabName][tableName] && <div style={{
                        width: "90%",
                        paddingRight: "0%",
                        paddingTop: "20px",
                        margin: "auto",
                        marginTop: "50px",
                        zoom: 100 / (global.pageZoom || 100)
                    }}>
                        <ReactHighcharts config={getCacheChartOption(tabName, tableName)} ref="chart"/>
                    </div>}
                </Row>
            );
        }

        let pairs = Object.keys(this.state.init[tabName]);

        return (
            <div key={tabName + "_cache_chart"} hidden={this.state.activeKey !== tabName}>
                {that.renderSelector(pairs)}
                {pairs.filter((pair) => pair === that.state.activePair).map((tableName) => {
                    return (renderSingleChart(tabName, tableName));
                })}
            </div>
        );
    }

    renderDynamicChart (tabName) {
        let that = this;

        function checkDataReady (tabName, tableName, chartName) {
            if (that.state.data[tabName]
                && that.state.data[tabName][tableName]
                && that.state.data[tabName][tableName][chartName]) {
                return that.state.dynamicDataReceived[chartName] === true;
                // return !Object.values(that.state.data[tabName][tableName][chartName]).every((arr) => arr.length === 0);
            }
            else {
                return false;
            }
        }

        function getChartOption (tabName, strategyKey, chartName) {
            return {
                chart: {
                    height: "40%",
                    events: {
                        load: function () {
                            // set up the updating of the chart each second

                            // let series = this.series;
                            setInterval(() => {
                                let chartData = that.state.data[tabName][strategyKey][chartName];

                                Object.keys(chartData).forEach((k) => {
                                    while (chartData[k].length > 0) {
                                        let point = that.state.data[tabName][strategyKey][chartName][k].shift();
                                        // series[i].addPoint(point, true, true);

                                        let k_str = `${tabName}|${strategyKey}|${chartName}|${k}`;
                                        if (that.state.dynamicData[k_str] === undefined) {
                                            return;
                                        }
                                        that.state.dynamicData[k_str].push(point);

                                        while (that.state.dynamicData[k_str].length > max_dynamic_data) {
                                            that.state.dynamicData[k_str].shift();
                                        }
                                    }
                                });
                            }, UPDATE_INTERVAL);

                            // new Date().getTime();
                        }
                    }
                },
                time: {
                    useUTC: false
                },
                credits: {
                    enabled: false
                },
                rangeSelector: {
                    buttons: [{
                        count: 3,
                        type: "minute",
                        text: "3M"
                    }, {
                        count: 15,
                        type: "minute",
                        text: "15M"
                    }, {
                        count: 30,
                        type: "minute",
                        text: "30M"
                    }, {
                        type: "all",
                        text: "All"
                    }],
                    inputEnabled: false,
                    selected: 0
                },
                title: {
                    text: `${strategyKey} - ${chartName}`
                },
                yAxis: {
                    resize: {
                        enabled: true
                    },
                    labels: {
                        align: "right",
                        x: -3
                    },
                    title: {
                        text: ""
                    }
                },
                exporting: {
                    enabled: false
                },
                legend: {
                    enabled: true
                },
                series: (function () {
                    let series = [];
                    let chartData = that.state.data[tabName][strategyKey][chartName];

                    Object.keys(chartData).forEach((chartKey, i) => {
                        let key = `${tabName}|${strategyKey}|${chartName}|${chartKey}`;

                        if (that.state.dynamicData[key] === undefined) {
                            getCacheData(key).then((points) => {
                                that.state.dynamicData[key] = points;
                                series[i] = {
                                    name: chartKey,
                                    data: points
                                };
                                // that.state.startReceiveDynamicData[key] = true;
                            }).catch((err) => {
                                console.log(err);
                                that.state.dynamicData[key] = [];
                                series[i] = {
                                    name: chartKey,
                                    data: []
                                };
                                // that.state.startReceiveDynamicData[key] = true;
                            });
                        }
                        else {
                            that.state.startReceiveDynamicData[key] = true;
                            series[i] = {
                                name: chartKey,
                                data: that.state.dynamicData[key] || []
                            };
                        }
                    });
                    return series;
                }())
            };
        }

        function getCacheData (cacheKey) {
            return new Promise((resolve, reject) => {
                $.ajax({
                    method: "get",
                    async: false,
                    url: cnf["restUrl"] + "/strategy_status/getCache/" + cacheKey,
                    success: (data) => {
                        if (data && typeof data === "string") {
                            data = JSON.parse(data);
                            // console.log(data);
                            resolve(data);
                        }
                    },
                    error: (err) => {
                        console.log(err);
                        reject(err);
                    }
                });
            });
        }

        function renderSingleKeyChart (tabName, strategyKey) {
            return (
                Object.keys(that.state.data[tabName][strategyKey]).map((chartName) => {
                    return (<Row>
                        {checkDataReady(tabName, strategyKey, chartName) && <div style={{
                            width: "90%",
                            paddingRight: "0%",
                            paddingTop: "20px",
                            margin: "auto",
                            marginTop: "50px",
                            zoom: 100 / (global.pageZoom || 100)
                        }}>
                            <ReactHighstock config={getChartOption(tabName, strategyKey, chartName)} ref="chart"/>
                        </div>}
                    </Row>);
                })
            );
        }

        let strategyKeys = Object.keys(this.state.init[tabName]);

        return (
            <div key={tabName + "_dynamic_chart"} hidden={this.state.activeKey !== tabName}>
                {that.renderSelector(strategyKeys)}
                {strategyKeys.filter((k) => k === that.state.activePair).map((strategyKey) => {
                    return (renderSingleKeyChart(tabName, strategyKey));
                })}</div>);
    }

    renderStepChart (tabName) {
        let that = this;
        if (that.state.data === undefined) {
            return null;
        }
        if (that.state.init[tabName] === undefined) {
            return null;
        }
        let identifiers = Object.keys(that.state.init[tabName]);

        function getStepChartPlotLines (tabName, tableName) {
            if (tableName.includes("FundingRates")) {
                // console.log('rows: ', that.state.init[tabName][tableName]['charts']);
                let time_span = length_map[tableName.split("@")[1]];
                // let tables = that.state.init[tabName][tableName]['charts'].find(table => table.startsWith('Ftx'));
                // if (tables) {
                //     let d = new Date();
                //     let hour = d.getHours();
                //     let timestamp = d.setHours(hour, 0, 0, 0);
                //     return Array.from(new Array(24 * time_span).keys()).map(x => {
                //         return {
                //             color: 'red',
                //             width: 0.5,
                //             value: time_span > 14 ? undefined : timestamp - x * 60 * 60 * 1000,
                //             dashStyle: 'longdashdot'
                //         }
                //     })
                // }
                // else {
                let d = new Date();
                let hour = d.getHours();
                let remainder = hour % 8;
                let timestamp = d.setHours(hour - remainder, 0, 0, 0);
                return Array.from(new Array(3 * time_span).keys()).map(x => {
                    return {
                        color: "red",
                        width: 0.5,
                        value: time_span > 14 ? undefined : timestamp - x * 8 * 60 * 60 * 1000,
                        dashStyle: "longdashdot"
                    };
                });
                // }

            }
            else if (tableName.includes("Hyperliquid")) {
                let d = new Date();
                let hour = d.getHours();
                let timestamp = d.setHours(hour, 0, 0, 0);

                return Array.from(new Array(24).keys()).map(x => {
                    return {
                        color: "red",
                        width: 0.35,
                        value: timestamp - x * 60 * 60 * 1000,
                        dashStyle: "longdashdot"
                    };
                });
            }
            else if (tableName.includes("BitMEX")) {
                let d = new Date();
                let hour = d.getHours();
                let remainder = (hour + 4) % 8;
                let timestamp = d.setHours(hour - remainder, 0, 0, 0);
                // let timestamp = d.setHours(hour, 0, 0, 0);

                return Array.from(new Array(3).keys()).map(x => {
                    return {
                        color: "red",
                        width: 0.5,
                        value: timestamp - x * 8 * 60 * 60 * 1000,
                        dashStyle: "longdashdot"
                    };
                });
            }
            else {
                let d = new Date();
                let hour = d.getHours();
                let remainder = hour % 8;
                let timestamp = d.setHours(hour - remainder, 0, 0, 0);
                let remainder_2 = (hour + 4) % 8;
                let timestamp_2 = d.setHours(hour - remainder_2, 0, 0, 0);

                return (Array.from(new Array(3).keys()).map(x => {
                    return {
                        color: "red",
                        width: 0.75,
                        value: timestamp - x * 8 * 60 * 60 * 1000,
                        dashStyle: "longdashdot"
                    };
                })).concat(Array.from(new Array(3).keys()).map(x => {
                    return {
                        color: "green",
                        width: 0.5,
                        value: timestamp_2 - x * 8 * 60 * 60 * 1000,
                        dashStyle: "dasddot"
                    };
                }));
            }
        }

        function calc_rate_mean (points_y) {
            const rate_mean = points_y.reduce((a, b) => a + b, 0) / points_y.length;
            return rate_mean < 1 ? ((rate_mean * 100).toFixed(3) + "%") : "";
        }

        function getStepChartSeries (tabName, tableName) {
            // console.log('getStepChartSeries tableName: ',tableName)
            if (tableName.includes("FundingRates")) {
                return that.state.init[tabName][tableName]["charts"].map((table, index) => {
                    return {
                        step: "left",
                        type: "line",
                        name: table,
                        data: that.state.data[tabName][tableName]["step"][index],
                        lineWidth: 2,
                        yAxis: 0,
                        marker: {
                            radius: 2
                        }
                    };
                });
            }
            else {
                return [{
                    step: "left",
                    type: "area",
                    name: tableName,
                    data: that.state.data[tabName][tableName]["step"][0],
                    lineWidth: 1,
                    yAxis: 0,
                    marker: {
                        radius: 0
                    }
                }, {
                    type: "line",
                    name: tableName.replace("next_rate", "price"),
                    data: that.state.data[tabName][tableName]["step"][1],
                    lineWidth: 1,
                    yAxis: 1,
                    marker: {
                        radius: 0
                    }
                }];
            }
        }

        function getStepChartOption (tabName, tableName) {

            if (that.state.data[tabName] === undefined || !that.state.data[tabName][tableName] === undefined) {
                return null;
            }

            let plotLines = getStepChartPlotLines(tabName, tableName);
            let seriesOptions = getStepChartSeries(tabName, tableName);

            return {
                chart: {
                    zoomType: isPC() ? "x" : undefined,
                    height: (Math.min(window.innerWidth, window.innerHeight) < 1000 && window.innerHeight > window.innerWidth) ? "60%" : "35%",
                },
                title: {
                    text: tableName
                },
                time: {
                    useUTC: false
                },
                credits: {
                    enabled: false,
                },
                legend: {
                    enabled: true,
                    labelFormatter: function () {
                        return this.name.endsWith(".rate") ? this.name.replace(".rate", " " + calc_rate_mean(this.yData)) : this.name;
                    },
                    itemHoverStyle: {
                        color: "white",
                        "font-weight": "bold",
                        fontSize: "14px"
                    },
                    itemHiddenStyle: {
                        "text-decoration": "line-through",
                        color: "grey"
                    }
                },
                xAxis: {
                    type: "datetime",
                    crosshair: true,
                    plotLines: plotLines
                },
                yAxis: [{
                    title: {
                        text: tableName.includes("next_rate") ? "Next_Rate" : "Rate"
                    },
                    labels: {
                        formatter: function () {
                            return (this.value * 100).toFixed(3) + "%";
                        }
                    },
                    gridLineWidth: 1,
                    softMax: 0.0001,
                    softMin: 0
                }, {
                    opposite: true,
                    title: {
                        text: "Price"
                    },
                }],
                series: seriesOptions,
                tooltip: {
                    split: true,
                    xDateFormat: "%Y-%m-%d %H:%M:%S",
                    pointFormatter: function () {
                        return "<span style=\"color:" + this.color + "\"> ● </span>"
                            + "<b>" + this.series.name + "</b>: "
                            + (this.series.name.endsWith("rate") ? ((this.y * 100).toFixed(3) + "%") : this.y);
                    }
                },
                plotOptions: {
                    area: {
                        fillColor: {
                            linearGradient: {
                                x1: 0,
                                y1: 0,
                                x2: 0,
                                y2: 1
                            },
                            stops: [
                                [0, "#7cb5ec"],
                                [1, "rgba(124, 181, 236, 0)"]
                            ]
                        },
                        marker: {
                            radius: 2
                        },
                        lineWidth: 1,
                        states: {
                            hover: {
                                lineWidth: 1
                            }
                        },
                        threshold: null
                    },
                    line: {
                        threshold: null
                    }
                },
            };
        }

        function renderSingleChart (tabName, tableName) {
            if (that.state.data[tabName][tableName].length === 0) {
                return null;
            }
            return (
                <Row>
                    {that.state.data[tabName][tableName]["step"] &&
                        <div style={{
                            width: "90%",
                            paddingRight: "0%",
                            paddingTop: "20px",
                            margin: "auto",
                            marginTop: "50px",
                            zoom: 100 / (global.pageZoom || 100)
                        }}>
                            <HighchartsReact
                                highcharts={Highcharts}
                                options={getStepChartOption(tabName, tableName)}
                                // allowChartUpdate={false}
                            />
                        </div>
                    }
                </Row>
            );
        }

        return (
            <div key={tabName + "_column_chart"} hidden={this.state.activeKey !== tabName}>
                {that.renderSelector(identifiers)}
                {identifiers.filter((identifier) => identifier === that.state.activePair).map((tableName) => {
                    return (renderSingleChart(tabName, tableName));
                })}
            </div>
        );
    }

    render () {
        if (this.state.errMsg) {
            return (<div align="center" style={{ height: "1000px" }}>
                <Spin style={{ paddingTop: "400px" }} size="large"
                      tip={typeof this.state.errMsg === "object" ? JSON.stringify(this.state.errMsg) : this.state.errMsg}/>
            </div>);
        }
        if (this.state.init === undefined) {
            return (<div align="center" style={{ height: "1000px" }}><Spin style={{ paddingTop: "400px" }} size="large"
                                                                           tip="Loading.."/></div>);
        }
        let tabs = this.state.data === undefined ? Object.keys(this.state.init) : Object.keys(this.state.data);
        // console.log('data-----------------', this.state.data)
        if (this.state.data === undefined) { // show the config tables when no data
            return (
                <div>
                    <Grid fluid={true} style={{ width: "95%", minHeight: "90%", minWidth: "1000px" }}>
                        Connecting...
                        <Row>
                            <Nav style={{ "margin": "0 -15px" }} bsStyle="pills" activeKey={this.state.activeKey}
                                 onSelect={k => this.handleSelect(k)}>
                                {tabs.map((tabName) => {
                                    if (this.state.init[tabName] !== undefined && this.state.init[tabName].length !== 0)
                                        return (<NavItem key={tabName} eventKey={tabName}>{tabName}</NavItem>);
                                    return null;
                                })}
                            </Nav>
                            {tabs.map((tabName) => {
                                if (tabName.includes("Monitor")) {
                                    return (<PortfolioTables key={tabName + "_Tables"} tabName={tabName}
                                                             data={this.state.init_data[tabName]}
                                                             tableElement={this.state.tableElement[tabName]}
                                                             dataStructure={this.state.init[tabName]}
                                                             activeKey={this.state.activeKey}/>);
                                }
                                else if (tabName.includes("Sum")) {
                                    return (<TableTab key={tabName}
                                                      tabName={tabName}
                                                      data={this.state.init_data[tabName]}
                                                      config={this.state.init[tabName]}
                                                      activeKey={this.state.activeKey}
                                                      portfolio={this.state.portfolio}/>);
                                }
                                else if (tabName.includes("Chart")) {
                                    return null;
                                }
                                else return (<PortfolioTables key={tabName + "_Tables"} tabName={tabName}
                                                              data={this.state.init_data[tabName]}
                                                              tableElement={this.state.tableElement[tabName]}
                                                              dataStructure={this.state.init[tabName]}
                                                              activeKey={this.state.activeKey}/>);
                            })}
                        </Row>
                    </Grid>
                </div>
            );
        }

        return (
            <div>
                <Grid fluid={true} style={{ width: "95%", minHeight: "90%", minWidth: "1000px" }}>
                    {this.ws && this.ws.closing ? "Reconnecting..." : ""}
                    <Row>
                        <Nav style={{ "margin": "0 -15px" }} bsStyle="pills" activeKey={this.state.activeKey}
                             onSelect={k => this.handleSelect(k)}>
                            {tabs.map((tabName) => {
                                if (this.state.init[tabName] !== undefined && this.state.init[tabName].length !== 0)
                                    return (<NavItem key={tabName} eventKey={tabName}>{tabName}</NavItem>);
                                return null;
                            })}
                        </Nav>
                        {tabs.filter(tab => tab === this.state.activeKey).map((tabName) => {
                            if (this.state.cleaning === true) {
                                return (
                                    <div key={tabName + "_cleaning_heap"} align="center" style={{ height: "1000px" }}>
                                        <Spin style={{ paddingTop: "400px" }} size="large" tip="Cleaning Heap..."/>
                                    </div>);
                            }
                            else if (tabName.includes("Monitor")) {
                                return (<PortfolioTables key={tabName + "_Tables"} tabName={tabName}
                                                         data={this.state.data[tabName]}
                                                         tableElement={this.state.tableElement[tabName]}
                                                         dataStructure={this.state.init[tabName]}
                                                         activeKey={this.state.activeKey}/>);
                            }
                            else if (tabName.includes("ActSum")) {
                                return (<TableTab key={tabName} tabName={tabName} data={this.state.data[tabName]}
                                                  config={this.state.init[tabName]}
                                                  activeKey={this.state.activeKey}
                                                  portfolio={this.state.portfolio}/>);
                            }
                            else if (tabName.includes("DynamicChart")) {
                                return this.renderDynamicChart(tabName);
                            }
                            else if (tabName.includes("SpreadChart")) {
                                return this.renderSpreadChart(tabName);
                            }
                            else if (tabName.includes("CacheChart")) {
                                return this.renderCacheChart(tabName);
                            }
                            else if (tabName.includes("StepChart")) {
                                return this.renderStepChart(tabName);
                            }
                            else if (tabName.includes("Chart")) {
                                return this.renderChart(tabName);
                            }
                            else return (<PortfolioTables key={tabName + "_Tables"} tabName={tabName}
                                                          data={this.state.data[tabName]}
                                                          tableElement={this.state.tableElement[tabName]}
                                                          dataStructure={this.state.init[tabName]}
                                                          activeKey={this.state.activeKey}/>);
                        })}
                    </Row>
                </Grid>
            </div>
        );
    }

    componentDidUpdate (preProps, preState) {
        if (preProps.location.search !== this.props.location.search) {
            console.log(`from ${preProps.location.search} to ${this.props.location.search}...`);

            this.closeWs();
            this.refresh();
        }
    }
}

export default PortfolioMonitor;



// WEBPACK FOOTER //
// ./src/view/PortfolioMonitor.jsx